import { useEffect, useState } from 'react'
import Draggable from 'react-draggable'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setResizedColumnWidths } from '../SpreadSheetDataProvider/actions'

swallowEvent = (e) -> e.stopPropagation()

export default ResizeableHandle = ({ c }) ->

  minCellWidth = 100

  [{
    columnWidths,
    resizedColumnWidths,
  }, dispatch] = useSpreadSheetData()

  [resizeOffset, setResizeOffset] = useState(0)

  recordDrag = ({ deltaX }) ->
    setResizeOffset(resizeOffset + deltaX)

  performResize = ->
    newWidth = (resizedColumnWidths[c] || columnWidths[c]) + resizeOffset
    newColWidths = {
      resizedColumnWidths...,
      [c]: Math.max(newWidth, minCellWidth)
    }
    dispatch(setResizedColumnWidths(newColWidths))
    setResizeOffset(0)

  throttledResize = _.throttle(performResize, 200)

  useEffect( ->
    return if resizeOffset is 0
    throttledResize()
    undefined
  , [resizeOffset])

  <Draggable
    axis="x"
    defaultClassName="DragHandle"
    defaultClassNameDragging="DragHandleActive"
    onDrag={(e, { deltaX }) ->
      recordDrag({ deltaX })
    }
    onMouseMove={swallowEvent}
    onMouseDown={swallowEvent}
    onMouseUp={swallowEvent}
    onClick={swallowEvent}
    position={{ x: 0 }}
  >
    <span
      style={{
        height: 40
        width: 5
        position: 'relative'
        left: 14
      }}
    />
  </Draggable>